__turbopack_context__.v({
  "genButton": "qGIoUG_genButton",
  "header": "qGIoUG_header",
  "label": "qGIoUG_label",
  "root": "qGIoUG_root",
});
